import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {USP} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/usp.types';
import {USPsSection_ArticleUSP} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useMemo} from 'react';

export const useUspsData = ({
  articleUsps,
  usps,
  selectedSize,
}: {
  articleUsps: USPsSection_ArticleUSP[];
  usps: USP[];
  selectedSize?: SizeSelection_Size;
}) => {
  return useMemo(() => {
    if (articleUsps.length) {
      // filter deliveryEstimationSection based on the selected size
      const deliveryEstimationSectionBySize = articleUsps.find(
        usp =>
          usp.type?.$case === 'deliveryEstimationSection' &&
          usp.type.deliveryEstimationSection.sizeId === selectedSize?.sizeId,
      );

      const uspsData = articleUsps.reduce((usps, item) => {
        switch (item.type?.$case) {
          case 'deliveryEstimationSection': {
            return deliveryEstimationSectionBySize &&
              !usps.some(usp => usp.type?.$case === 'deliveryEstimationSection')
              ? [...usps, deliveryEstimationSectionBySize]
              : usps;
          }
          default:
            return [...usps, item];
        }
      }, [] as USPsSection_ArticleUSP[]);

      return uspsData;
    }

    if (usps.length) {
      return normalizeUspData(usps);
    }

    return [];
  }, [articleUsps, selectedSize?.sizeId, usps]);
};

// the USPsView should support both USP and USPsSection_ArticleUSP data shape
const normalizeUspData = (usps: USP[]) => {
  const normalizedUsps: USPsSection_ArticleUSP[] = usps.map(usp =>
    usp.freeDeliveryProgressSection
      ? {
          type: {
            $case: 'movSection',
            movSection: {
              image: usp.image,
              freeDeliveryProgressSection: usp.freeDeliveryProgressSection,
            },
          },
        }
      : {type: {$case: 'standard', standard: {...usp}}},
  );

  return normalizedUsps;
};
